module.exports = __webpack_public_path__ + "static/ceramic07-6a7100b4cad4cd57fc65f2a6e22e0234.jpg";